export const environment = {
  production: false,
  enableIQIntegration: false,
  mapboxToken: 'MAPBOX_TOKEN_PLACEHOLDER',
  url: 'https://www.itaderp.com/backend/crm/web',
  firebase: {
    apiKey: 'AIzaSyCetwpOQQmucSHAoUa1FFM9wqJBjmB6xJQ',
    authDomain: 'greentek-245a7.firebaseapp.com',
    databaseURL: 'https://greentek-245a7.firebaseio.com',
    projectId: 'greentek-245a7',
    storageBucket: 'greentek-245a7.appspot.com',
    messagingSenderId: '262604010580'
  },
  apiNestJS: 'http://localhost:49004/api',
  apiECommerce: 'http://localhost:3001',
  apiECommerceKey: 'FRONTEND_API_KEY-1230989898986565321', // Angular API-Key for NestJS x-api-key header
  apiEtl: 'http://localhost:8000',
  cdnUpload: {
    url: 'https://api.smartimageserve.com/upload',
    folderName: 'ecommerceGTSImages',
  },
};